import { render, staticRenderFns } from "./UpdateInvestorStatusSuccessNotification.vue?vue&type=template&id=4217c931&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports